export const skillsData = [
    {
      title: "Languages",
      skills: [
        { name: "C", level: 85 },
        { name: "Python", level: 75 },
        { name: "Core Java", level: 90 },
        { name: "JavaScript", level: 80 },
        { name: "SQL", level: 70 }
      ]
    },
    {
      title: "Web Development",
      skills: [
        { name: "HTML/CSS/JS", level: 85 },
        { name: "React", level: 60 },
        { name: "Node.js / Express", level: 70 },
        { name: "Socket.IO", level: 50 },
        { name: "SpringBoot", level: 65 }
      ]
    },
    {
      title: "Databases",
      skills: [
        { name: "MongoDB", level: 80 },
        { name: "MySQL", level: 70 }
      ]
    },
    {
      title: "Tools & Frameworks",
      skills: [
        { name: "Git", level: 80 },
        { name: "TensorFlow", level: 50 },
        { name: "Pandas / NumPy", level: 75 },
        { name: "Docker", level: 40 }
      ]
    },
    {
      title: "AI",
      skills: [
        { name: "Machine Learning", level: 75 },
        { name: "Neural Network", level: 55 },
        { name: "NLP", level: 60 },
        { name: "Computer Vision", level: 50 },
        
      ]
    },
    {
      title: "Concepts",
      skills: [
        { name: "DSA", level: 80 },
        { name: "OOPs", level: 75 },
        { name: "OS", level: 65 },
        { name: "DBMS", level: 70 }
      ]
    },
    {
      title: "Platforms",
      skills: [
        { name: "VS Code", level: 90 },
        { name: "GitHub", level: 85 },
        { name: "Render", level: 80 }
      ]
    }
  ];
  